module.exports = __webpack_public_path__ + "media/landing_page/instacart-lifetime-lockup-4f317bfa.svg";